import { CardsByMonths, CardWithDate } from "../../store/calendar/selectors";
import {
	startOfYear,
	addMonths,
	areIntervalsOverlapping,
	isSameMonth,
} from "date-fns";
import { CardType } from "../../types/LibraryCard";

export interface CardsGroup {
	startDate: number;
	endDate?: number;
	endNextMonth?: boolean;
	startNextMonth?: boolean;
	cards: CardWithDate[];
}

export interface MonthWithCardGroup {
	month: Date;
	cardsGroup: CardsGroup[];
	endMonth?: Date;
}

export enum MonthType {
	Winter,
	Spring,
	Summer,
	Autumn,
}

export const getMonths = (cardByDates: CardsByMonths, date: Date) => {
	let currentMonth = startOfYear(date);
	const months: MonthWithCardGroup[] = [];
	const year = date.getFullYear();

	for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
		const booksOfMonth = cardByDates[monthIndex] ? cardByDates[monthIndex] : [];

		months.push({
			month: currentMonth,
			cardsGroup: findIntersection(booksOfMonth, currentMonth),
		});

		currentMonth = addMonths(currentMonth, 1);
	}

	return months;
};

// новые индексы месяцы сезонов (зима, т.д.)
const edgeMonths = [2, 5, 8, 11];

export const groupEmptyMonths = (months: MonthWithCardGroup[]) => {
	const newMonthsArray: MonthWithCardGroup[] = [];

	let lastEmptyMonths = 0;
	let emptyCount = 0;

	//newMonthsArray.push(months[0]);

	for (let i = 0; i < months.length; i++) {
		const month = months[i];

		if (month.cardsGroup.length === 0) {
			if (i == 0 || edgeMonths.indexOf(i) != -1) {
				newMonthsArray.push(month);
			}

			newMonthsArray[newMonthsArray.length - 1].endMonth = month.month;
		} else {
			emptyCount = 0;

			newMonthsArray.push(month);
		}
	}

	return newMonthsArray;
};

const findIntersection = (cards: CardWithDate[], month: Date): CardsGroup[] => {
	const sortedCards = cards.sort((a, b) => {
		return a.startDate.getTime() - b.startDate.getTime();
	});

	const newGroups: CardsGroup[] = [];

	const wantedReadBooksGroup: CardsGroup = {
		startDate: 0,
		cards: []
	}

	const startedFromPrevMonth: CardsGroup = {
		startDate: -1,
		cards: [],
		startNextMonth: true
	}

	sortedCards.forEach((card) => {
		// добавляем запланированные книги в одну группу
		if (card.type === CardType.WantRead) {
			wantedReadBooksGroup.cards.push(card);

			return;
		}

		if (!isSameMonth(card.startDate, month)) {
			startedFromPrevMonth.cards.push(card);

			return;
		}

		const lastGroupCard =
			newGroups.length > 0
				? newGroups[newGroups.length - 1].cards[
						newGroups[newGroups.length - 1].cards.length - 1
				  ]
				: null;

		if (
			lastGroupCard &&
			lastGroupCard.endDate &&
			card.endDate &&
			!newGroups[newGroups.length - 1].endNextMonth
		) {
			if (
				areIntervalsOverlapping(
					{
						start: lastGroupCard.startDate,
						end: lastGroupCard.endDate,
					},
					{
						start: card.startDate,
						end: card.endDate,
					}
				)
			) {
				newGroups[newGroups.length - 1].cards.push(card);

				return;
			}
		}

		newGroups.push({
			cards: [card],
			startDate: card.startDate.getDate(),
			endNextMonth: card.endDate ? !isSameMonth(month, card.endDate) : false,
		});
	});

	const newNewGroup: CardsGroup[] = [];

	if (startedFromPrevMonth.cards.length > 0) {
		newNewGroup.push(startedFromPrevMonth);
	}
	
	if (wantedReadBooksGroup.cards.length > 0) {
		newNewGroup.push(wantedReadBooksGroup);
	}

	newGroups.forEach((group) => {
		group.cards.forEach((card) => {
			newNewGroup.push({
				cards: [card],
				startDate: card.startDate.getDate(),
				endDate: group.cards.length === 1 ? card.endDate?.getDate() : null,
				endNextMonth: card.endDate
					? !isSameMonth(month, card.endDate)
					: false,
			});
		});
	});

	return newNewGroup;
};
